import React from "react";
import { createPortal } from "react-dom";
import { LogOut } from "lucide-react";

export default function LogoutConfirmModal({
    isOpen,
    user,
    onClose,
    onConfirm
}) {
    if (!isOpen) {
        return null;
    }

    return createPortal(
        <div className="fixed inset-0 z-[100000] flex items-center justify-center px-4 bg-black/30">
            <div className="bg-white rounded-3xl p-6 shadow-2xl w-full max-w-sm transform scale-100">
                <div className="flex flex-col items-center mb-6">
                    <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mb-4 text-red-500 shadow-inner">
                        <LogOut size={26} strokeWidth={2.5} />
                    </div>
                    <h3 className="text-xl font-black text-gray-900 mb-2 font-do-hyeon tracking-tight">로그아웃</h3>
                    <p className="text-gray-500 text-center text-sm font-medium leading-relaxed">
                        정말 로그아웃 하시겠습니까?<br />
                        {user?.isAnonymous && <span className="text-red-500 font-bold block mt-1 bg-red-50 px-2 py-0.5 rounded-md text-xs inline-block">⚠️ 게스트 데이터는 모두 삭제됩니다.</span>}
                    </p>
                </div>
                <div className="flex gap-3">
                    <button
                        onClick={onClose}
                        className="flex-1 py-3.5 rounded-2xl bg-gray-100 font-bold text-gray-600 hover:bg-gray-200 transition-colors"
                    >
                        취소
                    </button>
                    <button
                        onClick={onConfirm}
                        className="flex-1 py-3.5 rounded-2xl bg-red-500 font-bold text-white hover:bg-red-600 shadow-lg shadow-red-500/30 transition-all hover:scale-[1.02] active:scale-[0.98]"
                    >
                        로그아웃
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}
